import {HeaderProps} from "@/elements-react/catalog-layout/header/index.tsx";
import {HeaderMobileDefault} from "@/elements-react/catalog-layout/header/templates/header.default.tsx";
import {Templates, useTemplate} from "@/util-react/template.tsx";
import React from "preact/compat";
import {HeaderMobileBlackAndBlue} from "@/elements-react/catalog-layout/header/templates/header.black-and-blue.tsx";

const templates: Record<Templates, React.ComponentType<HeaderProps>> = {
    [Templates.DEFAULT]: HeaderMobileDefault,
    [Templates.BLACK_AND_BLUE]: HeaderMobileBlackAndBlue,
};

export const HeaderMobile = (props: HeaderProps) => {
    const template = useTemplate();
    const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

    return <TemplatedComponent {...props} />;
};